import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-right, margin, padding"} maskId="square-filled-radius-0-stroke-1-IconLayoutRight"><path d="M18 21H3V3H18V21Z" fill="currentColor"/><path d="M21 21H20V3H21V21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutRight;
